import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=51a84c22&"
import script from "./Root.vue?vue&type=script&lang=js&"
export * from "./Root.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_@babel+core@7.28.5_supports-color@9.4.0____98dfd1e4490f4915d683750b41a85eda/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports